export { createLogger, LoggerFactory, GlobalLogger, LogBuffer } from "co-addin-logging-build";
export { HttpLogTransport, ConsoleTransport, NoOpTransport } from "co-addin-logging-build";
export { StaticContextProvider } from "co-addin-logging-build";
export { defaultConfig, getBaseLoggerConfig } from "co-addin-logging-build";
export { MessageFormatter, LoggerErrorHandler } from "co-addin-logging-build";
export type {
  Logger,
  LoggerConfig,
  ILoggerContextProvider,
  LogTransport,
  LogEntry,
  LogLevel,
  LogContext,
  LoggerSessionInfo,
  LoggerEnvironmentInfo,
  HttpLogTransportOptions,
  HttpLogTransportStatus,
  CreateLoggerOptions,
  StaticContextProviderOptions,
} from "co-addin-logging-build";

export { WordLoggerContextProvider } from "./WordLoggerContextProvider";
export {
  initializeLogger,
  reinitializeLogger,
  restoreConsole,
  getLoggerEndpoint,
  getLoggerCleanup,
  setLoggerCleanup,
  getLoggerInstance,
  isLoggerInitialized,
} from "./LoggerInitializer";

export type { InitializeLoggerOptions } from "./LoggerInitializer";
